import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/Terms.module.css';
const PrivacyPolicy = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('privacy_policy')} | ESL`;
  }, [t]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>ESL {t('privacy_policy')}</h2>
      </div>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_intro_title')}</h2>
        <p className={styles.paragraph}>{t('pp_intro_dear')}</p>
        <p className={styles.paragraph}>{t('pp_intro_p1')}</p>
        <p className={styles.paragraph}>{t('pp_intro_p2')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_auto_title')}</h2>
        <p className={styles.paragraph}>{t('pp_auto_p1')}</p>
        <p className={styles.paragraph}>{t('pp_auto_p2')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_collection_title')}</h2>
        <p className={styles.paragraph}>{t('pp_collection_intro')}</p>

        <ul className={styles.list}>
          <li className={styles.listItem}><strong>{t('pp_signup_label')}</strong> {t('pp_signup_text')}</li>
          <li className={styles.listItem}><strong>{t('pp_log_label')}</strong> {t('pp_log_text')}</li>
          <li className={styles.listItem}><strong>{t('pp_cookies_label')}</strong> {t('pp_cookies_text')}</li>
          <li className={styles.listItem}><strong>{t('pp_usage_label')}</strong> {t('pp_usage_text')}</li>
          <li className={styles.listItem}><strong>{t('pp_transaction_label')}</strong> {t('pp_transaction_text')}</li>
          <li className={styles.listItem}><strong>{t('pp_aggregated_label')}</strong> {t('pp_aggregated_text')}</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_redemption_title')}</h2>
        <p className={styles.paragraph}>{t('pp_redemption_intro')}</p>
        <section className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>{t('pp_amendment_title')}</h3>
          <p className={styles.paragraph}>{t('pp_amendment_text')}</p>
        </section>

        <section className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>{t('pp_notification_title')}</h3>
          <p className={styles.paragraph}>{t('pp_notification_text')}</p>
        </section>

        <section className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>{t('pp_discretion_title')}</h3>
          <p className={styles.paragraph}><strong>{t('pp_discretion_label')}</strong> {t('pp_discretion_text')}</p>
        </section>

        <section className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>{t('pp_changes_notif_title')}</h3>
          <p className={styles.paragraph}>{t('pp_changes_notif_text')}</p>
        </section>

        <section className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>{t('pp_misc_title')}</h3>
          <p className={styles.paragraph}><strong>{t('pp_misc_label')}</strong> {t('pp_misc_text')}</p>
        </section>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_security_title')}</h2>
        <p className={styles.paragraph}>{t('pp_security_p1')}</p>
        <p className={styles.paragraph}>{t('pp_security_p2')}</p>
        <p className={styles.paragraph}>{t('pp_security_p3')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_links_title')}</h2>
        <p className={styles.paragraph}>{t('pp_links_p1')}</p>
        <p className={styles.paragraph}>{t('pp_links_p2')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_policy_changes_title')}</h2>
        <p className={styles.paragraph}>{t('pp_policy_changes_p1')}</p>
        <p className={styles.paragraph}>{t('pp_policy_changes_p2')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('pp_contact_title')}</h2>
        <p className={styles.paragraph}>{t('pp_contact_text')} <a href="mailto:support@esl.game">support@esl.game</a>.</p>
      </section>

      <footer className={styles.footer}>
        <p>&copy; 2025 ESL. {t('pp_footer')}</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
